export const locale = {
	lang: 'en',
	data: {
		home: {
			title: 'My Guglielmo Dashboard v2',
		},
		overview: {
			title: 'Overview',
			device: 'Devices',
			usage: 'Usage',
			users: 'Users',
			device_at_day: 'At day',
			average_usage: 'Average duration of connections',
			total_traffic_dow: 'Total traffic',
			total_traffic_upload_download: 'Total traffic',
			average_traffic_upload_download: 'Average Total',
			distribution_users_dow: 'Weekly distribution',
			distribution_users_type: 'Authentication type',
			minutes_abbrev: 'min.',
			hours_abbrev: 'hours',
			user_new: 'New users',
			user_return: 'Returning users',
			traffic_download: 'Traffic in Download',
			traffic_upload: 'Traffic in Upload',
		},
		troubleshooting: {
			title: 'Troubleshooting',
			logs: {
				title: 'Logs',
				table: {
					timestamp: 'Timestamp',
					mac_address: 'Mac Address',
					username: 'Username',
					result: 'Result',
					reason: 'Reason',
					message: 'Message',
					edit: 'Edit',
				},
				noLocationSelected: 'Select a location to view the logs',
			},
			sessions: {
				title: 'Sessions',
				table: {
					session_id: 'Session ID',
					location_id: 'Location ID',
					start_time: 'Start Time',
					end_time: 'End Time',
					duration: 'Duration',
					mac_address: 'Mac Address',
					ip: 'IP Address',
					username: 'Username',
					edit: 'Edit',
					view: 'View'
				},
				noLocationSelected: 'Select a location to view the sessions',
			},
			events: {
				title: 'Event Stats',
				table: {
					timestamp: 'Timestamp',
					location_id: 'Location ID',
					mac_address: 'Mac Address',
					ip: 'IP Address',
				},
			},
		},
		sessionspage: {
			title: 'Profile Details',
		},
		segments: {
			title: 'Segments',
		},
		realtime: {
			title: 'Real-Time',
			device: 'Devices',
			users: 'Users',
			device_txt: 'Total number of devices',
			users_txt: 'Total number of users',
			connectionsPerMinute: 'Number of connections per minute',
		},
		users: {
			title: 'Users registered to the service',
		},
		traffic: {
			title: 'Traffic',
		},
		cashback: {
			title: 'Cashback',
			period: 'Period',
			message: 'Calculating your Cashback',
			error: {
				location_id: 'You must select a location',
			},
		},
		passpoint: {
			invitations: {
				create: 'Create Invitation',
			},
		},
		roaming: {
			title: 'Roaming',
		},
		location_group: {
			title: 'Location Group',
			create: 'Create Location Group',
		},
		general: {
			user: 'User',
			fromWeek: 'From the week',
			untilWeek: 'To week',
			fromMonth: 'From month',
			untilMonth: 'To month',
			fromYear: 'From the year',
			untilYear: 'All\ year',
			fromDay: 'From day',
			toDay: 'To day',
			error: {
				locationGroup: 'Location group does not exist',
				location: 'Location data does not exist',
			},
			selectAll: 'All locations',
			no: 'No',
			yes: 'Yes',
		},
		invitation: {
			title: 'Passpoint Invitations',
			details: 'Detail',
			create: 'Create Invitation',
		},
		trend: {
			title: 'Trend',
			sub_title: 'Comparison of the number of sessions over two time periods',
			select_period: 'Select the period',
			dayInfo: 'Shows the sessions for the selected day',
			weekInfo: 'Compares the selected week with the previous one',
			monthInfo:
				'Compares the selected month with the same month of the previous year',
			yearInfo: 'Compares the selected year with the previous year',
			reference_period: 'Reference period ',
			reference_period_1: 'Reference period 1',
			reference_period_2: 'Reference period 2',
			from: 'From',
			to: 'To',
			time_trends: 'Time trends',
			year: 'Year',
			errorDateGranularity: 'Error: the date is not correct',
		},
		account: {
			title: 'Dashboard accounts',
			create: 'Create account',
		},
		god_user: {
			title: 'Dashboard God',
			create: 'Create God User',
		},
		sessions: {
			title: 'Sessions',
			hoursSessionsDistribution: 'Daily distribution',
			daySessionsDistribution: 'Weekly distribution',
			weekSessionsDistribution: 'Daily timetable',
			sessionsTrend: 'Time trend',
			session_number: 'Session number',
		},
		graph: {
			hourUsersDistribution: 'Daily distribution',
			dayUsersDistribution: 'Weekly distribution',
			weekUsersDistribution: 'Daily timetable',
			newReturnUsersDistribution: 'Time trend',

			hourTrafficDistribution: 'Daily distribution',
			dayTrafficDistribution: 'Weekly distribution',
			weekTrafficDistributionUpload: 'Daily timetable Upload',
			weekTrafficDistributionDwonload: 'Daily timetable Download',
			trafficTrend: 'Time trend',

			total: 'Total',
			peak_positive: 'Peak positive',
			peak_negative: 'Peak negative',
			average: 'Average',
		},
		select: {
			day: 'Day',
			week: 'Week',
			month: 'Month',
			year: 'Year',
			custom_date: 'Date',
		},
		location: {
			title: 'Service Monitoring',
			total: 'Locations',
			never_seen: 'Working',
			silent: 'Silent',
			active: 'In activation',
		},
		table: {
			id: 'ID',
			name: 'Name',
			ip_address: 'IP Address',
			last_connection: 'Last connection',
			session_number: 'Session number',
			status: 'Status',
			active: 'Traffic occurred in the last 3 days',
			never_seens: 'Traffic never occurred',
			silent: 'Traffic never occurred in the last 3 days',
			allStatus: 'All status',
			search: 'Search',
			reset: 'Reset',
			rank: 'rank',
			value: 'Value',
			noData: 'No Data',
			enable_monitoring: 'Enable monitoring',
			enable_notify: 'Notifications',
			sponsor_email: 'Sponsor Email',
			first_name: 'Name',
			last_name: 'Surname',
			email: 'Email',
			identity_email: 'Identity email',
			phone_number: 'Phone number',
			marketing_consent: 'Marketing',
			profile_consents: 'Profile',
			strategy: 'Authentication method',
			filter_strategy: 'Filter',
			all_strategies: 'All',
			passpoint_only: 'Passpoint only',
			captive_only: 'Captive portal only',
			verified: 'Verified',
			last_update: 'Last update',
			show_sessions: 'Details',
			actions: 'Actions',
			password: 'Password',
			searchTooltip: 'Search by id, email, first name, last name, phone',
			location_id: 'Location Name',
			location: 'Location',
			mac_address: 'Mac Address',
			download: 'Download',
			upload: 'Upload',
			duration: 'Duration',
			start: 'Start',
			stop: 'Stop',

			username: `Username`,
			role: 'Role',
			brand: 'Brand',
			visible_sections: 'Visible sections',
			locations: 'Locations',

			option: 'Options',
			registered_at: 'Registered at',

			channel: 'Channel',
			created_at: 'Created at',
			last_login: 'Last login',
			since: 'Valid since',
			until: 'Valid until',
			os_version: 'OS Version',
			mac: 'Mac',
			expiration: 'Expiration',
			valid: 'Valid',
			disabled: 'Disabled',
			notActiveYet: 'Not active yet',
			expired: 'Expired',
			notValid: 'Not valid',

			scope: 'Scope',
			enabled: 'Enabled',
			description: 'Description',
			tenant: 'Tenant',
			hidden_sections: 'Hidden sections',

			metadata: 'Metadati',

			permissions_group: 'Permissions Group',
			permissions: 'Permissions',
			locations_group: 'Locations Group',

			selectScope: 'Select Scope',
			selectBrand: 'Select Brand',
			selectHiddenSections: 'Select Hidden Sections',

			max_devices: 'Max allowed devices',
			notes: 'Notes',
			policy: 'Policy',
			sent_at: 'Sent at',
			type: 'Type',
			user_type: 'User Type',
			valid_from: 'Valid from',
			valid_to: 'Valid to',
			expiration_hours: 'Expiration hours',

			session_id: 'Session ID',
			profile_id: 'Profile ID',

			tot_locations: 'N. Locations',
		},
		ranking: {
			title: 'Ranking',
			top_ten_users: 'Top 10 Locations by User Count',
			top_ten_connections: 'Top 10 Locations by Connection Count',
			ranking_users: 'Ranking users',
			ranking_connections: 'Ranking Sessions',
			yesterday: 'YESTERDAY',
			last_week: 'LAST WEEK',
			last_month: 'LAST MONTH',
			last_year: 'LAST YEAR',
			showAll: 'Show all',
			weekInfo: 'Compares the first day of the week with the last',
			monthInfo:
				'Compares the first day of the month with the last day of the month',
			custom_range: 'Compares the range of the two selected dates',
		},
		modal: {
			location_settings: 'Location settings for the entire Location Group',
			silent_threshold: 'Silent Location Threshold',
			list_address_email: 'List of email addresses',
			solved_threshold: 'Solved Location Threshold',
			notifications_enabled: 'Notifications enabled',
			monitoring_enabled: 'Monitoring enabled',
			location_settings_alert: 'Alert Locations',
			disable: 'Disable Profile',
			warning: 'Warning',
			v_old_dashboard_button: 'Switch to the old version',
			v_old_dashboard_title: `Switching to the previous version of MyGuglielmo.`,
			v_old_dashboard_text: `You are about to be redirected to the previous version of the MyGuglielmo dashboard. <br/> Do you want to proceed?`,
			info_alert_location:
				'It seems that your user does not have permissions to view the locations. Contact the administrator to get the necessary permissions',
			popconfirmtitle: `Attention! The operation disable ALL profiles associated with the device. Are you sure you want to proceed?`,
			success: {
				save_settings: 'Settings saved successfully',
				change_status: 'Status changed successfully',
				disable_profile: 'Profile disabled successfully',
				delete_invitation: 'Invitation deleted successfully',
				send_mail_invitation: 'Email sent successfully',
				bulk_invitation: 'Bulk invitations sent successfully',
			},
			error: {
				save_settings: 'Error saving settings',
				change_status: 'Error changing status',
				disable_profile: 'Error disabling profile',
				delete_invitation: 'Error deleting invitation',
				send_mail_invitation: 'Error sending email',
				bulk_invitation: 'Error sending bulk invitations',
			},
			changeUntil: 'Change until',
			create: 'Create',
			edit: 'Update',
			delete: 'Delete',
		},
		alert: {
			success: {
				bulk_invitation: 'Bulk invitations sent successfully',
				save_settings: 'Settings saved successfully',
				change_status: 'Status changed successfully',
				accountUpdated: 'Account Updated successfully',
				accountCreated: 'Account Created successfully',
				accountDeleted: 'Account Deleted successfully',
				untilDateUpdate: 'Until date updated successfully',
				locationGroupCreated: 'Location Group created successfully',
				locationGroupUpdated: 'Location Group updated successfully',
				locationGroupDeleted: 'Location Group deleted successfully',
				godUserCreated: 'God User created successfully',
				godUserDeleted: 'God User deleted successfully',
				canCSVExported: 'You can download the file',
				invitations: {
					create: 'Invitation created successfully',
					delete: 'Invitation deleted successfully',
					update: 'Invitation updated successfully',
					send: 'Invitation sent successfully',
				},
			},
			error: {
				bulk_invitation: 'Error sending bulk invitations',
				save_settings: 'Errror saving settings',
				change_status: 'Error changing status',
				accountUpdated: 'Error updating account',
				accountCreated: 'Error creating account',
				accountDeleted: 'Error deleting account',
				requiredFieldAlert: 'Please fill in all required fields',
				requiredField: 'Required field',
				emailNotValid: 'Email not valid',
				untilDateUpdate: 'Error updating until date',
				locationGroupCreated: 'Error creating Location Group',
				locationGroupUpdated: 'Error updating Location Group',
				locationGroupDeleted: 'Error deleting Location Group',
				godUserCreated: 'Error creating God User',
				godUserDeleted: 'Error deleting God User',
				invitations: {
					create: 'Error creating invitation',
					delete: 'Error deleting invitation',
					update: 'Error updating invitation',
					send: 'Error sending invitation',
					list: 'Error listing invitations',
				},
			},
			info: {
				invitations: {
					list: 'There are no Passpoint invitations yet.',
				},
			},
			warning: {
				canCSVExported: 'There is no data to export',
			},
		},
		time_range: {
			LAST_7_DAYS: 'Last 7 days',
			LAST_30_DAYS: 'Last 30 days',
			LAST_180_DAYS: 'Last 180 days',
			LAST_365_DAYS: 'Last 365 days',
			WEEK: 'Select the week',
			MONTH: 'Select the month',
			QUARTER: 'Select the quarter',
		},
		tooltip: {
			cashback:
				'Cashback is calculated based on the total traffic in your location',
			overview_device: 'Total number of connected devices',
			overview_usage: 'Total number of hours connected',
			overview_user:
				'Total number of unique users without distinction between new and returning users',
			// overview_total_traffic_dow: 'Total download and upload traffic',
			overview_total_traffic_dow: 'Average daily traffic per device',
			overview_traffic_upload_download: 'Total download and upload traffic',
			overview_average_traffic_upload_download:
				'Average traffic per day of the week',
			// overview_distribution_users_dow:'Average traffic per hour of the day and day of the week',
			overview_distribution_users_dow:
				'Total daily traffic distribution per device',
			overview_users_type:
				'Distribution of the type of authentication used to access the service',
			realtime_connectionsPerMinute: 'Session trends in the last 15 minutes',
			realtime_device_txt:
				'Total number of devices currently connected to the service',
			realtime_users_txt:
				'Total number of users currently connected to the service',
			users_hourUsersDistribution:
				'Average distribution of users by hour of the day',
			users_dayUsersDistribution:
				'Average distribution of users by day of the week',
			users_weekUsersDistribution:
				'Average distribution of users by hour of the day and day of the week',
			users_newReturnUsersDistribution:
				'Temporal distribution of new and returning users',
			sessions_hoursSessionsDistribution:
				'Average distribution of sessione by hour of the day',
			sessions_daySessionsDistribution:
				'Average distribution of sessions by day of the week',
			sessions_weekSessionsDistribution:
				'Average distribution of sessions by hour of the day and day of the week',
			sessions_sessionsTrend: 'Temporal distribution of sessions',
			traffic_hourTrafficDistribution:
				'Average distribution of traffic by hour of the day',
			traffic_dayTrafficDistribution:
				'Average distribution of traffic by day of the week',
			traffic_weekTrafficDistributionUpload:
				'Average distribution of upload traffic by hour of the day and day of the week',
			traffic_weekTrafficDistributionDownload:
				'Average distribution of download traffic by hour of the day and day of the week',
			traffic_trafficTrend: 'Temporal distribution of traffic',
			trend_weekInfo:
				'Compares the sessions of the selected week with the previous one',
			trend_monthInfo:
				'Compares the sessions of the selected month with the same month of the previous year',
			trend_yearInfo:
				'Compares the sessions of the selected year with the previous year',
			monitoring_total: 'Total Locations',
			monitoring_active:
				'Total locations registered in the system that have logged in at least once in the last x days (x is the number of days set as the threshold)',
			monitoring_silent:
				'Total locations registered in the system that have not generated any traffic for at least x days (x is the number of days set as the threshold)',
			monitoring_inActiv:
				'Total locations registered in the system that have never made any connections',
			clients_total:
				'Total users who have used the service, including those who attempted to log in without validating the data used during login (email or phone number)',
			clients_verified:
				'Total users who have completed the registration process',
			clients_mktg: 'Total users who have given marketing consent',
			clients_prof: 'Total users who have given consent for profiling',
			show: 'Show',
		},
		client: {
			totals: 'Totals',
			verified: 'Verified',
			marketing_consent: 'Contactable',
			profile_consent: 'Profile consent',
		},
		client_sessions: {
			title: 'Client Sessions',
		},
		header: {
			period: 'Period',
			locationGroup: 'Gruppo',
			locationId: 'Location',
			last_15_minutes: 'Last 15 minutes',
			allLocations: 'All locations',
			goBackUserList: 'Go back to the user list',
			goBack: 'Go back',
		},
		component: {
			button: {
				addLocation: 'Add location',
				delete: 'Delete',
				save: 'Save',
				cancel: 'Cancel',
			},
			select: {
				locationGroup: 'Location Group',
				location: 'Locations',
			},
		},
	},
};
